import { combineEpics } from 'redux-observable';
import favoritesEpicsRoot from './favorites';

export const favoritesEpic = combineEpics(favoritesEpicsRoot);
